export default "__VITE_ASSET__CBaFnGly__"